// import React, { useState, useEffect, useRef } from "react";
// import Countryslide from "../Countryslide/Countryslide";
// import Addproduct from "../Addproduct";
// import axios from "axios";
// import { Constants } from "../../../endPoints";
// import { useHistory, useLocation } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";
// import { Tab } from "bootstrap";

// export default function Homesearch() {
//   const history = useHistory();
//   const location = useLocation();
//   const dropdownRef = useRef(null);

//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [countries, setCountries] = useState([]);
//   const [selections, setSelections] = useState([]);
//   const [categories, setCategories] = useState([]);

//   const [country, setCountry] = useState("");
//   const [selection, setSelection] = useState("");
//   const [category, setCategory] = useState("");

//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   const [selectedCountryText, setSelectedCountryText] = useState("Search by Country");
//   const [selectedSelectionText, setSelectedSelectionText] = useState("Main Selection");
//   const [selectedCategoryText, setSelectedCategoryText] = useState("Select Category");

//   // useEffect(() => {
//   //   // Always open modal if this component is active
//   //   document.body.classList.add("openModal");

//   //   // Activate Shop By Style tab
//   //   const tabButton = document.getElementById("nav-home-tab");
//   //   const tabContent = document.getElementById("nav-home");
//   //   if (tabButton && tabContent) {
//   //     const tab = new Tab(tabButton);
//   //     tab.show();             // show tab
//   //     tabContent.classList.add("openModal"); // styling
//   //   }

//   //   // Cleanup: remove class when component unmounts
//   //   return () => {
//   //     document.body.classList.remove("openModal");
//   //     if (tabContent) tabContent.classList.remove("openModal");
//   //   };
//   // }, [location.pathname]); // runs every time you navigate

//   // useEffect(() => {
//   //   const tabButtons = document.querySelectorAll('[data-bs-toggle="tab"]');

//   //   tabButtons.forEach((btn) => {
//   //     btn.onclick = (e) => {
//   //       e.preventDefault(); // prevent default link behavior

//   //       // Add modal open class
//   //       document.body.classList.add("openModal");

//   //       // Remove openModal from all tab panes
//   //       document.querySelectorAll(".tab-pane").forEach((el) => el.classList.remove("openModal"));

//   //       // Add openModal to target tab
//   //       const target = document.querySelector(btn.dataset.bsTarget);
//   //       if (target) target.classList.add("openModal");

//   //       // Show the tab using bootstrap
//   //       const tab = new Tab(btn);
//   //       tab.show();
//   //     };
//   //   });

//   //   return () => {
//   //     tabButtons.forEach((btn) => (btn.onclick = null)); // cleanup
//   //   };
//   // }, []);

//   // Check login
//   useEffect(() => {
//     const token = localStorage.getItem("authToken");
//     if (token) {
//       try {
//         jwtDecode(token);
//         setIsLoggedIn(true);
//       } catch {
//         setIsLoggedIn(false);
//       }
//     } else {
//       setIsLoggedIn(false);
//     }
//   }, []);

//   // Fetch Countries
//   useEffect(() => {
//     axios.get(Constants.listCounty).then((res) => {
//       setCountries(res.data.data || []);
//     });
//   }, []);

//   // Fetch Main Selection
//   useEffect(() => {
//     axios.get(Constants.listSelection).then((res) => {
//       if (res.data.status === 1) setSelections(res.data.list || []);
//     });
//   }, []);

//   // Fetch Categories
//   useEffect(() => {
//     axios.get(Constants.listCategory).then((res) => {
//       if (res.data.status === 1) setCategories(res.data.list || []);
//     });
//   }, []);

//   // Open modal automatically on load
//   // useEffect(() => {
//   //   document.body.classList.add("openModal");
//   //   const tabButton = document.getElementById("nav-home-tab");
//   //   if (tabButton) {
//   //     const tab = new Tab(tabButton);
//   //     tab.show(); // show Shop By Style tab by default
//   //   }
//   // }, []);

//   // Close dropdown if clicked outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setActiveDropdown(null);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   // Handle Search redirect
//   const handleSearch = () => {
//     const query = new URLSearchParams();
//     if (country) query.append("country", country);
//     if (selection) query.append("selection", selection);
//     if (category) query.append("category", category);
//     history.push(`/listing?${query.toString()}`);
//   };

//   return (
//     <div className="bannerSec">
//       <div className="bnrimg">
//         <img src={`${process.env.PUBLIC_URL}/assets/images/bnerimge.jpg`} alt="" />
//         <div className="bnrtxt">
//           <div className="container">
//             <div className="bnrtxtinr">
//               <strong
//                 onClick={() => history.push("/sell-product")}
//                 style={{ cursor: "pointer" }}
//               >
//                 Sell
//               </strong>
//               <h1>
//                 Jewelry. <br /> Join the <br /> Market.
//               </h1>
//               <a href="#url" className="themebtn">
//                 Sell your Jewelry
//               </a>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="bnerForm">
//         <div className="container">
//           <div className="bnerfrmpnel">
//             <div className="bnerlink">
//               <nav>
//                 <div className="nav nav-tabs" id="nav-tab" role="tablist">
//                   <button
//                     className="active"
//                     id="nav-home-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#nav-home"
//                     type="button"
//                     role="tab"
//                     aria-controls="nav-home"
//                     aria-selected="true"
//                   >
//                     Shop By Style
//                   </button>
//                   <button
//                     id="nav-profile-tab"
//                     data-bs-toggle="tab"
//                     data-bs-target="#nav-profile"
//                     type="button"
//                     role="tab"
//                     aria-controls="nav-profile"
//                     aria-selected="false"
//                   >
//                     Start Selling
//                   </button>
//                 </div>
//               </nav>
//             </div>

//             <div className="bneropen">
//               <div className="tab-content" id="nav-tabContent">
//                 {/* SEARCH TAB */}
//                 <div
//                   className="tab-pane fade show active"
//                   id="nav-home"
//                   role="tabpanel"
//                   aria-labelledby="nav-home-tab"
//                   tabIndex="0"
//                 >
//                   <div className="filterform" ref={dropdownRef}>
//                     <div className="flterhding">
//                       <h2>Shop By Style</h2>
//                       {/* <a
//                         href="#"
//                         className="closeBtn"
//                         onClick={(e) => {
//                           e.preventDefault();
//                           document.body.classList.remove("openModal");
//                           document
//                             .querySelectorAll(".tab-pane")
//                             .forEach((el) => el.classList.remove("openModal"));
//                         }}
//                       >
//                         Close
//                       </a> */}
//                     </div>

//                     {/* COUNTRY */}
//                     <div className="country-select">
//                       <div
//                         className="select-box"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setActiveDropdown(activeDropdown === "country" ? null : "country");
//                         }}
//                       >
//                         <span className="selected-text">{selectedCountryText}</span>
//                       </div>
//                       <ul
//                         className="country-list"
//                         style={{ display: activeDropdown === "country" ? "block" : "none" }}
//                       >
//                         {countries.map((item) => (
//                           <li
//                             key={item.id}
//                             onClick={() => {
//                               setCountry(item.id);
//                               setSelectedCountryText(item.country);
//                               setActiveDropdown(null);
//                             }}
//                           >
//                             <img src={item.country_symbols} alt="" />
//                             {item.country}
//                           </li>
//                         ))}
//                       </ul>
//                     </div>

//                     {/* MAIN SELECTION */}
//                     <div className="country-select">
//                       <div
//                         className="select-box"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setActiveDropdown(activeDropdown === "selection" ? null : "selection");
//                         }}
//                       >
//                         <span className="selected-text">{selectedSelectionText}</span>
//                       </div>
//                       <ul
//                         className="country-list"
//                         style={{ display: activeDropdown === "selection" ? "block" : "none" }}
//                       >
//                         {selections.map((item) => (
//                           <li
//                             key={item.id}
//                             onClick={() => {
//                               setSelection(item.id);
//                               setSelectedSelectionText(item.name);
//                               setActiveDropdown(null);
//                             }}
//                           >
//                             <img src={`${Constants.imageBaseURL}/${item.image}`} alt="" />
//                             {item.name}
//                           </li>
//                         ))}
//                       </ul>
//                     </div>

//                     {/* CATEGORY */}
//                     <div className="country-select">
//                       <div
//                         className="select-box"
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           setActiveDropdown(activeDropdown === "category" ? null : "category");
//                         }}
//                       >
//                         <span className="selected-text">{selectedCategoryText}</span>
//                       </div>
//                       <ul
//                         className="country-list"
//                         onClick={(e) => e.stopPropagation()}
//                         style={{ display: activeDropdown === "category" ? "block" : "none" }}
//                       >
//                         {categories.map((item) => (
//                           <li
//                             key={item.id}
//                             onClick={() => {
//                               setCategory(item.id);
//                               setSelectedCategoryText(item.name);
//                               setActiveDropdown(null);
//                             }}
//                           >
//                             <img src={`${Constants.imageBaseURL}/${item.image}`} alt="" />
//                             {item.name}
//                           </li>
//                         ))}
//                       </ul>
//                     </div>

//                     <div className="frmbtnsrch">
//                       <button onClick={handleSearch}>
//                         <i>
//                           <img src={`${process.env.PUBLIC_URL}/assets/images/search.svg`} alt="" />
//                         </i>
//                         Show Results
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 {/* SELL TAB */}
//                 <div className="tab-pane fade" id="nav-profile">
//                   {isLoggedIn ? (
//                     <>
//                       <div className="flterhding">
//                         {/* <a
//                           href="#"
//                           className="closeBtn"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             document.body.classList.remove("openModal");
//                             document
//                               .querySelectorAll(".tab-pane")
//                               .forEach((el) => el.classList.remove("openModal"));
//                           }}
//                         >
//                           Close
//                         </a> */}
//                       </div>
//                       <Addproduct />
//                     </>
//                   ) : (
//                     <div className="frmbtnsrch text-center py-4">
//                       <div className="flterhding">
//                         {/* <a
//                           href="#"
//                           className="closeBtn"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             document.body.classList.remove("openModal");
//                             document
//                               .querySelectorAll(".tab-pane")
//                               .forEach((el) => el.classList.remove("openModal"));
//                           }}
//                         >
//                           Close
//                         </a> */}
//                       </div>
//                       <button onClick={() => history.push("/login")} className="themebtn">
//                         Login to Start Selling
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import Countryslide from "../Countryslide/Countryslide";
import Addproduct from "../Addproduct";
import axios from "axios";
import { Constants } from "../../../endPoints";
import { useHistory } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import Select, { components } from "react-select";

export default function Homesearch() {
  const history = useHistory();

  const [countries, setCountries] = useState([]);
  const [selections, setSelections] = useState([]);
  const [categories, setCategories] = useState([]);

  const [country, setCountry] = useState(null);
  const [selection, setSelection] = useState(null);
  const [category, setCategory] = useState(null);

  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // ✅ Login Check
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        jwtDecode(token);
        setIsLoggedIn(true);
      } catch {
        setIsLoggedIn(false);
      }
    }
  }, []);

  // ✅ APIs
  useEffect(() => {
    axios.get(Constants.listCounty).then((res) => {
      setCountries(res.data.data || []);
    });
  }, []);

  useEffect(() => {
    axios.get(Constants.listSelection).then((res) => {
      if (res.data.status === 1) setSelections(res.data.list || []);
    });
  }, []);

  useEffect(() => {
    axios.get(Constants.listCategory).then((res) => {
      if (res.data.status === 1) setCategories(res.data.list || []);
    });
  }, []);

  useEffect(() => {
    if (selection?.value === 6 && selection.value === 7) {
      setCategory(null);
    }
  }, [selection]);

  // ✅ Options
  const countryOptions = countries.map((i) => ({
    value: i.id,
    label: i.country,
    image: i.country_symbols,
  }));

  const selectionOptions = selections.map((i) => ({
    value: i.id,
    label: i.name,
    image: i.image,
  }));

  const categoryOptions = categories.map((i) => ({
    value: i.id,
    label: i.name,
    image: i.image,
  }));

  // ✅ Custom Option
  const CustomOption = (props) => (
    <div
      {...props.innerProps}
      style={{
        display: "flex",
        alignItems: "center",
        padding: "10px",
      }}
    >
      {props.data.image && (
        <img
          src={
            props.data.image.includes("http")
              ? props.data.image
              : `${Constants.imageBaseURL}/${props.data.image}`
          }
          alt=""
          style={{ width: 26, height: 26, marginRight: 10 }}
        />
      )}
      {props.data.label}
    </div>
  );

  // ✅ Filled Arrow Icon (NO divider line)
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <span style={{ fontSize: "18px", color: "#000" }}>▼</span>
      </components.DropdownIndicator>
    );
  };

  // ❌ Remove separator line
  const IndicatorSeparator = () => null;

  // ✅ Styles (NO BORDER + LIGHT GRAY)
  const customStyles = {
    control: (provided) => ({
      ...provided,
      height: "63px",
      minHeight: "63px",
      borderRadius: "47px",
      padding: "0 20px",
      backgroundColor: "#f5f5f5",
      border: "none", // ❌ removed border
      boxShadow: "none",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: "10px 12px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "63px",
    }),
    indicatorSeparator: () => ({
      display: "none", // ❌ remove vertical line
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: "10px",
      marginTop: "5px",
    }),
  };

  // ✅ Search
  const handleSearch = () => {
    const query = new URLSearchParams();

    if (country) query.append("country", country.value);
    if (selection) query.append("selection", selection.value);
    if (category) query.append("category", category.value);

    history.push(`/listing?${query.toString()}`);
  };

  return (
    <div className="bannerSec">
      <div className="bnrimg">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/bnerimge.jpg`}
          alt=""
        />

        <div className="bnrtxt">
          <div className="container">
            <div className="bnrtxtinr">
              <strong
                onClick={() => history.push(isLoggedIn ? "/sell-product" : "/register")}
                style={{ cursor: "pointer" }}
              >
                Sell
              </strong>

              <h1>
                Jewelry. <br /> Join the <br /> Market.
              </h1>

              <a
                className="themebtn"
                onClick={() => history.push(isLoggedIn ? "/sell-product" : "/register")}
              >
                Sell your Jewelry
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="bnerForm">
        <div className="container">
          <div className="bnerfrmpnel">

            {/* Tabs */}
            <div className="bnerlink">
              <nav>
                <div className="nav nav-tabs">
                  <button
                    className="active"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-home"
                  >
                    Shop By Style
                  </button>

                  <button
                    data-bs-toggle="tab"
                    data-bs-target="#nav-profile"
                  >
                    Start Selling
                  </button>
                </div>
              </nav>
            </div>

            <div className="bneropen">
              <div className="tab-content">

                {/* SEARCH TAB */}
                <div className="tab-pane fade show active" id="nav-home">
                  <div className="filterform">

                    {/* ✅ MOBILE GAP FIX */}
                    <div
                      className="flterhding"
                      style={{
                        marginBottom: "20px",
                      }}
                    >
                      <h2 style={{ marginBottom: "10px", marginTop: "30px" }}>
                        Shop By Style
                      </h2>
                    </div>

                    {/* DROPDOWNS */}
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "15px",
                      }}
                    >
                      <Select
                        options={countryOptions}
                        placeholder="Search by Country"
                        value={country}
                        onChange={setCountry}
                        styles={customStyles}
                        components={{
                          Option: CustomOption,
                          DropdownIndicator,
                          IndicatorSeparator,
                        }}
                        isSearchable
                      />

                      <Select
                        options={selectionOptions}
                        placeholder="Main Selection"
                        value={selection}
                        onChange={setSelection}
                        styles={customStyles}
                        components={{
                          Option: CustomOption,
                          DropdownIndicator,
                          IndicatorSeparator,
                        }}
                        isSearchable
                      />

                      {selection?.value !== 6 && selection?.value !== 7 && (
                        <Select
                          options={categoryOptions}
                          placeholder="Select Category"
                          value={category}
                          onChange={setCategory}
                          styles={customStyles}
                          components={{
                            Option: CustomOption,
                            DropdownIndicator,
                            IndicatorSeparator,
                          }}
                          isSearchable
                        />
                      )}
                    </div>

                    {/* BUTTON */}
                    <div className="frmbtnsrch">
                      <button onClick={handleSearch}>
                        <i>
                          <img src={`${process.env.PUBLIC_URL}/assets/images/search.svg`} alt="" />
                        </i>
                        Show Results
                      </button>
                    </div>

                  </div>
                </div>

                {/* SELL TAB */}
                <div className="tab-pane fade" id="nav-profile">
                  {isLoggedIn ? (
                    <Addproduct />
                  ) : (
                    <div className="frmbtnsrch py-4">
                      <button
                        onClick={() => history.push("/login")}
                        className=""
                      >
                        Login to Start Selling
                      </button>
                    </div>
                  )}
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}